export default "__VITE_ASSET__sOYTXOjI__"